import React from 'react';
import styled from 'styled-components';
import colors from '../../../styles/common/colors';
import devices from '../../../styles/common/devices';
import sizes from '../../../styles/common/sizes';
import { typography } from '../../../styles/common/typography';

interface SwitchButton {
  active: boolean;
}

const StyledSwitchButton = styled.div<SwitchButton>`
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: flex-start;
  align-items: center;

  button {
    width: 35px;
    background-color: ${(props) => (props.active ? colors.dark_tangerine : colors.secondary_color.variant_two)};
    border-radius: 11px;
    border: 1px solid ${(props) => (props.active ? colors.dark_tangerine : colors.secondary_color.variant_two)};
    box-sizing: border-box;
    padding: 0;
    transition: all 300ms ease-in-out;
    cursor: pointer;
    outline: none;
    &::after {
      content: '';
      width: 17px;
      height: 17px;
      background-color: ${colors.white};
      border-radius: 50%;
      box-shadow: 0px 1px 3px rgba(30, 30, 30, 0.3);
      transition: all 300ms ease-in-out;
      transform: ${(props) => (props.active ? 'translate(16px)' : 'translate(0)')};
      display: block;
    }
  }
  span {
    font-family: ${typography.fonts.body};
    font-size: ${sizes.base};
    color: ${colors.text_grey};
    margin-left: 10px;

    @media ${devices.tablet} {
      font-size: ${sizes.md};
    }
  }
`;

interface SwitchProps {
  active: boolean;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  text?: string;
}

export const Switch = (props: SwitchProps) => {
  const { active = false, onClick, text } = props;

  return (
    <StyledSwitchButton active={active}>
      <button type="button" onClick={onClick}></button>
      <span>{text}</span>
    </StyledSwitchButton>
  );
};
